module.exports = __webpack_public_path__ + "img/img_world_map.5c6fc300.png";